import { INIT_TODAYS_RATE } from '../../reducers/actions';
export default function initTodaysRate(rateKey) {
  return {
    type: INIT_TODAYS_RATE,
    rateKey: rateKey
  };
}